import { Block } from "baseui/block";
import { addMonths } from "date-fns";
import { useEffect, useState } from "react";
import { FormattedDate, useIntl } from "react-intl";
import { ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { getSum2, ICounterAndData } from "./utils";
import React from "react";


interface SingleMonthlyEnergyProps {
    data: ICounterAndData[], 
    monthOffset: number, 
    dimension: string, 
    squareMeter: number,
    isCurrrency: boolean,
    currencyCode?: string | undefined,
}

function SingleMonthlyEnergy(props: SingleMonthlyEnergyProps ) {
    const [total,setTotal] = useState(0);
    const [totalPerM2,setTotalPerM2] = useState(0);

    useEffect(() => {
        const sum = getSum2(props.data);
        setTotal(sum);
        setTotalPerM2(sum/props.squareMeter);
    },[props.data,props.squareMeter])


    const style = props.isCurrrency ? 'currency' : 'decimal'
    const dimPerM2 = props.isCurrrency ? '/m²' : props.dimension + '/m²';
    const dim = props.isCurrrency ? '' : props.dimension;

    return (
        <Block display={'flex'} alignItems='baseline'>
            <ValueDisplayWithLabel small={props.monthOffset !== 0} label={<FormattedDate value={addMonths(new Date(), props.monthOffset)}
                year="numeric"
                month="short"></FormattedDate>} style={style} currencyCode={props.currencyCode}  value={total} dimension={dim}></ValueDisplayWithLabel>
            <ValueDisplayWithLabel small label={''}  style={style} currencyCode={props.currencyCode} value={totalPerM2} dimension={dimPerM2}></ValueDisplayWithLabel>
        </Block>
    )
}

export default React.memo(SingleMonthlyEnergy)